import React from 'react';
import NavComplete from './Component/Navbar1';
import { Container } from 'react-bootstrap';

const ReviewPage = () => {
  return (
    <div>
      <NavComplete/>
      <Container>
     
      </Container>
    </div>
  );
};

export default ReviewPage;